var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row mb--small"},[_c('visitors'),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-xs-12"},[_c('div',{staticClass:"mb--small"},[_c('average-time')],1),_vm._v(" "),_c('conversions')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7bc6b9ad","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/screens/Metrics/components/metrics/Metrics.vue
// module id = 1483
// module chunks = 1